import Section1 from "./Section1";
import Section2 from "./Section2";
import SectionDelivery from "./SectionDelivery";
import './Main.css'
function Main() {

    return (<>
        <main>
            <Section1></Section1>
            <Section2></Section2>
            <SectionDelivery></SectionDelivery>
        </main>


    </>)
}
export default Main;